"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteDataAsync = exports.retrieveDataAsync = exports.saveDataAsync = exports.StorageDeleteError = exports.StorageRetrieveError = exports.StorageSaveError = void 0;
var localforage_1 = __importDefault(require("localforage"));
/**
 * Base class for storage operation errors
 */
var StorageError = /** @class */ (function (_super) {
    __extends(StorageError, _super);
    function StorageError(message, originalError) {
        var _a;
        var _this = _super.call(this, message) || this;
        _this.originalError = originalError;
        _this.name = 'StorageError';
        (_a = Error.captureStackTrace) === null || _a === void 0 ? void 0 : _a.call(Error, _this, _this.constructor);
        return _this;
    }
    return StorageError;
}(Error));
/**
 * Error thrown when saving data fails
 */
var StorageSaveError = /** @class */ (function (_super) {
    __extends(StorageSaveError, _super);
    function StorageSaveError(key, originalError) {
        var _this = _super.call(this, "Failed to save data for key: ".concat(key), originalError) || this;
        _this.name = 'StorageSaveError';
        return _this;
    }
    return StorageSaveError;
}(StorageError));
exports.StorageSaveError = StorageSaveError;
/**
 * Error thrown when retrieving data fails
 */
var StorageRetrieveError = /** @class */ (function (_super) {
    __extends(StorageRetrieveError, _super);
    function StorageRetrieveError(key, originalError) {
        var _this = _super.call(this, "Failed to retrieve data for key: ".concat(key), originalError) || this;
        _this.name = 'StorageRetrieveError';
        return _this;
    }
    return StorageRetrieveError;
}(StorageError));
exports.StorageRetrieveError = StorageRetrieveError;
/**
 * Error thrown when removing data fails
 */
var StorageDeleteError = /** @class */ (function (_super) {
    __extends(StorageDeleteError, _super);
    function StorageDeleteError(key, originalError) {
        var _this = _super.call(this, "Failed to delete data for key: ".concat(key), originalError) || this;
        _this.name = 'StorageDeleteError';
        return _this;
    }
    return StorageDeleteError;
}(StorageError));
exports.StorageDeleteError = StorageDeleteError;
/**
 * Saves a value to storage asynchronously.
 * @param key The key of the item to save.
 * @param value The value to save.
 * @throws {StorageSaveError} If saving fails
 */
var saveDataAsync = function (key, value) { return __awaiter(void 0, void 0, void 0, function () {
    var error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, localforage_1.default.setItem(key, value)];
            case 1:
                _a.sent();
                return [3 /*break*/, 3];
            case 2:
                error_1 = _a.sent();
                console.error('Failed to save to storage:', error_1);
                throw new StorageSaveError(key, error_1 instanceof Error ? error_1 : undefined);
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.saveDataAsync = saveDataAsync;
/**
 * Retrieves a value from storage asynchronously.
 * @param key The key of the item to retrieve.
 * @returns The value associated with the key, or null if not found.
 * @throws {StorageRetrieveError} If retrieval fails
 */
var retrieveDataAsync = function (key) { return __awaiter(void 0, void 0, void 0, function () {
    var error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, localforage_1.default.getItem(key)];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                error_2 = _a.sent();
                console.error('Failed to get from storage:', error_2);
                throw new StorageRetrieveError(key, error_2 instanceof Error ? error_2 : undefined);
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.retrieveDataAsync = retrieveDataAsync;
/**
 * Removes a key-value pair from storage asynchronously.
 * @param key The key of the item to remove.
 * @throws {StorageDeleteError} If deletion fails
 */
var deleteDataAsync = function (key) { return __awaiter(void 0, void 0, void 0, function () {
    var error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, localforage_1.default.removeItem(key)];
            case 1:
                _a.sent();
                return [3 /*break*/, 3];
            case 2:
                error_3 = _a.sent();
                console.error('Failed to remove from storage:', error_3);
                throw new StorageDeleteError(key, error_3 instanceof Error ? error_3 : undefined);
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.deleteDataAsync = deleteDataAsync;
